import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useAnalyticsByLineQuery, {
	type useAnalyticsByLineQuery$data,
	type useAnalyticsByLineQuery$variables,
} from './components/AnalyticsByLine/__generated__/useAnalyticsByLineQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export const preloadContentAnalyticsViewers = (
	contentId: string,
): Promise<{
	data: useAnalyticsByLineQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> =>
	query<useAnalyticsByLineQuery$data, useAnalyticsByLineQuery$variables>({
		query: useAnalyticsByLineQuery,
		variables: { contentId },
	});
